export type LegalDocId = 'terminos' | 'privacidad' | 'salud'

export const legalDocs = [
  {
    id: 'terminos',
    label: 'Términos y condiciones',
    title: 'Términos y condiciones',
    updated: 'Última actualización: octubre 2026',
    sections: [
      {
        heading: 'Aceptación de los términos',
        body: 'Al usar este sitio web y solicitar el Fitness Check de Evaluación Fitness Jseefect, aceptas estos términos y condiciones. Si no estás de acuerdo con alguno de ellos, te pedimos no utilizar el sitio ni nuestros servicios.',
      },
      {
        heading: 'Descripción del servicio',
        body: 'Jseefect ofrece coaching fitness en español, orientación de entrenamiento, hábitos y alimentación general. El Fitness Check gratuito es una evaluación inicial informativa para entender tu punto de partida. No representa una oferta obligatoria ni garantiza tu aceptación en un programa de coaching.',
      },
      {
        heading: 'Elegibilidad',
        body: 'Debes tener al menos 18 años para solicitar el Fitness Check o contratar cualquier servicio. Al enviar tus datos confirmas que la información proporcionada es verdadera y está actualizada.',
      },
      {
        heading: 'Resultados',
        body: 'No garantizamos resultados específicos. Los cambios físicos dependen del punto de partida, la constancia, el estilo de vida, la genética y la adherencia de cada persona al proceso. Las fotos y testimonios mostrados son experiencias individuales y no representan un resultado típico o asegurado.',
      },
      {
        heading: 'Responsabilidad del usuario',
        body: 'Eres responsable de consultar a tu médico antes de iniciar cualquier programa de ejercicio o cambio en tu alimentación, y de detener cualquier actividad si sientes dolor, mareo o malestar. Participas en cualquier actividad física bajo tu propio riesgo.',
      },
      {
        heading: 'Propiedad intelectual',
        body: 'Todo el contenido de este sitio, incluyendo textos, imágenes, logotipos, planes y materiales, pertenece a Evaluación Fitness Jseefect. No puede copiarse, distribuirse ni usarse con fines comerciales sin autorización por escrito.',
      },
      {
        heading: 'Limitación de responsabilidad',
        body: 'En la medida permitida por la ley, Jseefect no será responsable por lesiones, daños o pérdidas derivadas del uso de la información del sitio o de la aplicación de recomendaciones sin la debida supervisión médica.',
      },
      {
        heading: 'Cambios a estos términos',
        body: 'Podemos actualizar estos términos en cualquier momento. La versión vigente será siempre la publicada en este sitio, con su fecha de actualización.',
      },
    ],
  },
  {
    id: 'privacidad',
    label: 'Política de privacidad',
    title: 'Política de privacidad',
    updated: 'Última actualización: octubre 2026',
    sections: [
      {
        heading: 'Información que recopilamos',
        body: 'Cuando solicitas tu Fitness Check podemos recopilar tu nombre, email, teléfono, ciudad y estado, tu objetivo físico, tus obstáculos actuales y tu nivel de entrenamiento. También podemos recibir información técnica básica, como tipo de dispositivo o navegador.',
      },
      {
        heading: 'Cómo usamos tu información',
        body: 'Usamos tus datos para revisar tu caso, contactarte por WhatsApp, email o teléfono con el siguiente paso, personalizar nuestras recomendaciones y mejorar nuestros servicios. No usamos tu información para fines distintos a los descritos aquí.',
      },
      {
        heading: 'Con quién la compartimos',
        body: 'No vendemos ni alquilamos tu información personal. Solo la compartimos con herramientas necesarias para operar el servicio (por ejemplo, formularios, mensajería o almacenamiento), que están obligadas a protegerla, o cuando la ley lo requiera.',
      },
      {
        heading: 'Comunicaciones',
        body: 'Al enviar tus datos aceptas que te contactemos sobre tu solicitud. Puedes pedir en cualquier momento que dejemos de contactarte respondiendo “STOP” o escribiéndonos directamente.',
      },
      {
        heading: 'Seguridad',
        body: 'Tomamos medidas razonables para proteger tu información. Sin embargo, ningún sistema de transmisión o almacenamiento en internet es 100% seguro.',
      },
      {
        heading: 'Tus derechos',
        body: 'Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento. Si resides en un estado con leyes de privacidad específicas (como California), puedes ejercer los derechos que esas leyes te otorgan.',
      },
      {
        heading: 'Menores de edad',
        body: 'Nuestros servicios no están dirigidos a menores de 18 años y no recopilamos intencionalmente información de menores.',
      },
      {
        heading: 'Contacto',
        body: 'Para cualquier pregunta sobre tu privacidad o tus datos, escríbenos por WhatsApp al +1 (689) 299-5809.',
      },
    ],
  },
  {
    id: 'salud',
    label: 'Aviso de salud',
    title: 'Aviso de salud y resultados',
    updated: 'Última actualización: octubre 2026',
    sections: [
      {
        heading: 'No es consejo médico',
        body: 'La información de este sitio y del coaching es educativa y de acompañamiento. No sustituye el diagnóstico, tratamiento ni consejo de un médico, nutricionista certificado u otro profesional de salud.',
      },
      {
        heading: 'Consulta a tu médico',
        body: 'Antes de comenzar cualquier programa de ejercicio o cambio de alimentación, especialmente si tienes alguna condición médica, lesión, embarazo o tomas medicamentos, consulta a un profesional de salud.',
      },
      {
        heading: 'Resultados individuales',
        body: 'Los resultados pueden variar según el punto de partida, constancia, estilo de vida y adherencia al proceso. Las transformaciones mostradas son casos reales, pero no garantizan que obtendrás los mismos resultados.',
      },
    ],
  },
] as const
